module.exports = __webpack_public_path__ + "static/img/fast-food-outline.dc664e7a.svg";